export const NetworkQualityLevel = {
  UNKNOWN: 0,
  EXCELLENT: 1,
  GOOD: 2,
  FAIR: 3,
  POOR: 4,
  VERY_POOR: 5,
  DISCONNECTED: 6,
}
